import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { Province, WithMeta } from '@ygoargentina/sdk/api/api.types';

export const listProvinces = async (countryId: number) =>
  getGraphQLQueryClient(null).request<WithMeta<Province>>(
    gql`
      query provinces($filters: ProvinceFilters) {
        data: provinces(filters: $filters) {
          data {
            id
            name
          }
        }
      }
    `,
    { filters: { countryId } }
  );
